<template>
  <div class="browse_cell">
      <div class='input_zone'>
        <!-- <form> -->
        <div class="search">
            <div class='show_iterm_title'>Submit your task</div>
            <div class="form_line" >
                <label>GWAS summary statistics file </label>
                <input type="file" name="gwas_file"  @change="getFile">
            </div>
            <div class='show_iterm_text'><span style="font-weight: bold; color:red">Note: </span>
                the file must only contain three columns with header, i.e.,
                 "CHR" (chromosome number); "BP" (base pair postion, based on hg19/38); "P" (P value). We strongly recommend 
                 you to compress your file with "gz" format. See 
                 <a :href="exmple_gwas" target="_blank">example</a>. You can generate such file by our proposed <a :href="github_GWAS" target="_blank">script</a>.
                  <!-- You can generate such file by our proposed <a :href="github_GWAS" target="_blank">script</a>.  -->
                  </div>
            <div class="form_line" >
                <label>Reference genome version</label>
                <select id='genome_id' class="input_select" name="genome" v-model="refGenome">
                    <option v-for="item in genomeVal" :value ="item.value" :key="item.value" >{{item.text}}</option>
                </select>
            </div>
            <div class="form_line" >
                <label>Population</label>
                <select id='pop_id' class="input_select" name="population" v-model="refPop">
                    <option v-for="item in populationVal" :value ="item.value" :key="item.value">{{item.text}}</option>
                </select>
            </div>
<!-- Advanced options -->
            <div class="form_line" >
                <label>Multiple test correction method</label>
                <select id='method_id' class="input_select" name="method" v-model="method">
                    <option v-for="item in methodVal" :value ="item.value" :key="item.value">{{item.text}}</option>
                </select>
            </div>
            <div class="form_line" >
                <label>Error rate</label>
                <input type="text" name="error_rate" v-model="errorRate"  class="input_form">
            </div>
            <div class="form_line" >
                <label>Email (optional)</label>
                <input type="text" name="error_rate" v-model="email" class="input_form" style="width:300px">
            </div>
            <div class='show_iterm_text'><span style="font-weight: bold; color:red">Note: </span>
                    send an email to you when the task is completed.
                  </div>
            <div class="btn">
                <button type="submit" @click="submitTask()"><img :src="subIcon"/>Submit</button>
                <button type="reset" @click="resetForm()"><img :src="resIcon" />Reset</button>
            </div>
            <div class="return_msg" v-html="returnMsg" v-show="returnMsg!=''"></div>
        </div>
      </div>
  </div>
</template>

<script>
import {api_dir} from '@/bus.js'
import axios from 'axios/dist/axios.min';
import subIcon from '@/assets/img/submit.png';
import resIcon from '@/assets/img/reset.png';


axios.defaults.timeout = 1000*1000;
// import loading_ico from '@/assets/img/loading.gif';

export default {
  name: 'Submit',
  data () {
    return {
        finishRun:false,
        nofinishMsg:'',
        subIcon:subIcon,
        resIcon:resIcon,
        populationVal:[
            {'value':'EUR','text':'EUR'},
            {'value':'EAS','text':'EAS'},
            {'value':'AFR','text':'AFR'},
            {'value':'AMR','text':'AMR'},
            {'value':'SAS','text':'SAS'},
        ],

        genomeVal:[
            {'value':'hg19','text':'hg19'},
            {'value':'hg38','text':'hg38'}
        ],

        gwasColNames:[
            {'name':'chr','text':'Chromosome number column'},
            {'name':'bp','text':'Base pair position column'},
            {'name':'pvalue','text':'P value column'},
        ],

        methodVal:[
            {'text':'Adjusted Bonferroni correction','value':'bonf'},
        ],

        
        echartsDataCate:[],
        echartsDataIndexCate:[],
        echartsDataCategoryCate:[],
        colorGroupKeyCate:'',
        xAxisNameCate:'',
        echartsFromaterFuncPhenoCate:'',


        file:'',
        exmple_gwas:'static/resources/gwas_summary.txt.gz',
        github_GWAS:'https://github.com/pmglab/SPA/tree/main/extra',

        refDB:'hs',
        refPop:'EUR',
        refGenome:'hg19',
        method:'bonf',
        errorRate:'0.05',
        email:'',
        resultsInfo:'No results',
        returnMsg:'',
    }
  },

  methods:{
    getFile:function(e){
        this.file=e.target.files[0]
    },
    fileSize:function(){
        var fileSize=this.file.size
        if (!fileSize){
            alert("Please select GWAS summary file!");
            return false;
        }
        if(fileSize >200*1024*1024){
            alert("The file should be less than 200MB!");
            return false;
        }else if((/[^0-9E\.-]+/g).test(this.errorRate)==true){
            alert("Error format error rate: "+this.errorRate);
            return false;
        }
        return true;
    }, 


    resetForm:function(){
        this.refDB='hs'
        this.refPop='EUR'
        this.refGenome='hg19'
        this.method='bonf'
        this.errorRate='0.05'
    },
    submitTask:function(){
        if (!this.fileSize()){
            return false
        }
        var _this=this
        _this.returnMsg='<span style="font-style: italic">Submitting ... Please wait patiently</span>'
        let formdata = new FormData()
        formdata.append('file',this.file)
        formdata.append('pop',this.refPop.trim())
        formdata.append('ref_genome',this.refGenome.trim())
        formdata.append('multi_test',this.method.trim())
        formdata.append('fwer',this.errorRate.trim())
        formdata.append('chr',"CHR")
        formdata.append('bp',"BP")
        formdata.append('p',"P")
        formdata.append('email',_this.email.trim())
        formdata.append('action',"submit_task")
        formdata.append('func',"gec")
        var url=api_dir+'/gec_api.php'
          axios({
            method:"post",
            url:url,
            headers: {
                'Content-Type':'multipart/form-data;charset=UTF-8',
            },
            data:formdata,
            onUploadProgress: progressEvent => {
                let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
                _this.returnMsg='<span style="font-style: italic">Submitting ... Please wait patiently<br>Upload progress: '+complete+'</span>' 
            }
        })
            .then(function (response) {
                var jsonObj = JSON.parse(JSON.stringify(response.data));
                var task_id=jsonObj['task_id']
               if(!task_id){
                    _this.returnMsg='<span style="color:red">Failed!</span> \
                        Please check your inputs: '+jsonObj['file_header_error']
               }else{
                    // TODO : 跳转至结果页面
                    _this.$router.push({path:'/result?task_id='+task_id});
               }
            })
            .catch(function (error) {
                _this.showTaskID=true
                _this.returnMsg='<span style="color:red">Failed!</span>,\
                                        Network error'
                console.log(error)
            });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.input_zone{
    /* display: inline; */
    /* height: 530px; */
    width: 100%;
    margin: 0 auto;
}


::-webkit-scrollbar {display:none}

.form_line {
    /* margin-right: 20px; */
	vertical-align:middle;
	display: inline-block;
	width:100%;
	text-align: left;
    font-weight: bold;
    margin: 5px 20px;
    font-size: 16px;
}

.return_msg{
    vertical-align:middle;
	display: inline-block;
	width:80%;
	text-align: left;
    margin: 5px 20px;
    font-size: 16px;
    line-height: 30px;
    padding: 10px;
    background: #FDF6EC;
}

.form_line label{
	margin-right: 20px;
	vertical-align:middle;
	display: inline-block;
	text-align: right;
    font-weight: bold;
}

.show_iterm_title{
    text-align: left;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
    padding-left: 10px;
    font-size: 18px;
    color: #006652;
}

.show_iterm_text{
    text-align: left;
    font-size: 13px;
    margin-top:5px ;
}

.form_line select {
	vertical-align: middle;
    height: 34px;
    font-size: 14px;
    padding-left: 10px;
    padding-right: 10px;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

.btn{
	margin-top: 20px;
	margin-bottom: 20px;
}
.btn button{
	margin:0px 5px;
	cursor:pointer;
	display: inline-block;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 6px 12px;
    font-size: 14px;

    border-radius: 4px;
	
	color: #ffffff;

}
.btn button[type='submit']{
	background-color: #4db3e9;
}
.btn button[type='reset']{
	background-color: #df4937;

}
.btn button[type='submit']:hover{
	background-color: #2b73b3;
}
.btn button[type='reset']:hover{
	background-color: #962d21;

}

.btn button img{
	height: 14px;
	vertical-align: middle;
	margin-right:3px;
}


.input_form{
    vertical-align: middle;
    height: 26px;
    font-size: 14px;
	padding-left: 10px;
    /*line-height: 34px;*/
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}


.form_line,.btn,.show_iterm_text{
    margin-left: 30px;
}
.show_iterm_text{
    margin-left: 40px;
}

.form_line select, .input_form{
    height: 28px;
}

.results_msg{
    padding: 0px 30px 15px 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/submit.vue